import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TokenStorageService } from '../../services/token-storage.service';
import { UserService } from '../../services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loading = false;
  errorMessage: string;
  isLoggedIn = false;
  isLoginFailed = false;
  role: string;
  email:string;
  firstname:string;
  civilite: string;
  lastname:string;
  fieldTextType: boolean;
  usertype: any;
  userTypes: Array<{ value: string; label: string }> = [];
  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private auth: AuthService,
              private userservice: UserService,
              private tokenStorage: TokenStorageService
              ) { }

  ngOnInit() {
   
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.role = this.tokenStorage.getUser();
      this.email=this.tokenStorage.getUser();
      this.firstname=this.tokenStorage.getUser().Firstname;
      this.lastname=this.tokenStorage.getUser().Lastname;
      this.civilite=this.tokenStorage.getUser().civilite;
      this.role=this.tokenStorage.getUser().role;
    }
    
   
    this.loginForm = this.formBuilder.group({
      email: [null, [Validators.required]],
      password: [null, Validators.required],
      userType: new FormControl('', Validators.required), // Add userType control

    });
        // Load user types dynamically from the environment
        this.userTypes = environment.availableUserTypes || [];

        // Auto-assign the single user type if there's only one
        if (this.userTypes.length === 1) {
          this.loginForm.get('userType')?.setValue(this.userTypes[0].value);
        }
  }

  onLogin() {
    this.loading = true;
    const email = this.loginForm.get('email').value;
    const password = this.loginForm.get('password').value;
    const usertype = this.loginForm.get('userType').value;

    this.auth.login(email, password, usertype).subscribe({
      next: data => {
        this.tokenStorage.saveToken(data.accessToken);
        this.tokenStorage.saveUser(data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.role = this.tokenStorage.getUser().role;
        this.usertype = this.tokenStorage.getUser().usertype;

        this.firstname=this.tokenStorage.getUser().Firstname;
        this.lastname=this.tokenStorage.getUser().Lastname;
        this.civilite=this.tokenStorage.getUser().civilite;
       // this.userservice.connectUser(this.tokenStorage.getUser().userId,this.tokenStorage.getUser())
        if(this.usertype=='Metier')
        {
          this.router.navigate(['tasks']).then(
            () => {
              window.location.reload()        
            }
          )
        }
else
{
  this.router.navigate(['home']).then(
    () => {
      window.location.reload()        
    }
  )
}
      },
      error: error => {
        this.loading = false;
        this.isLoginFailed = true;
      }
    });


    
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
}